/**
 * De vorm die elk e-mailadres in het systeem moet hebben.
 *
 * Bewust conservatief in plaats van RFC-volledig: precies één `@`, geen spaties, een domein van
 * punt-gescheiden delen en een topleveldomein van minstens twee letters. Adressen die volgens de RFC
 * mogen maar die in een asiel nooit voorkomen (aanhalingstekens in het lokale deel, een IP als
 * domein) vallen af — gevraagd worden een geldig adres anders te schrijven is een veel kleiner
 * probleem dan post die bounced op een adres dat nooit had kunnen werken.
 *
 * Houd gelijk met `Emailadres.PATROON` in de api
 * (api/src/main/java/nl/docasoft/fawkes/api/common/web/Emailadres.java).
 */
const PATROON = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;

/** Of `waarde` een e-mailadres is. Een lege waarde is géén adres — of dat erg is, bepaalt de aanroeper. */
export function isEmailadres(waarde: string): boolean {
  return PATROON.test(waarde.trim());
}
